// @flow
export const getLetters = (value: string) => String(value).replace(/[^a-zA-Z\s*]/g, '');

export const formatName = (nameString: string) => getLetters(nameString);

export default formatName;
